const defaultSchema = require('./schemas/defaultSchema');
const santanderSchema = require('./schemas/santanderSchema');
const itauSchema = require('./schemas/itauSchema');
const itiSchema = require('./schemas/itauSchema/itiSchema');
const bancoDoBrasilSchema = require('./schemas/bancoDoBrasilSchema');
const caixaSchema = require('./schemas/caixaSchema');
const celcoinSchema = require('./schemas/celcoinSchema');
const interSchema = require('./schemas/interSchema');
const agiplanSchema = require('./schemas/agiplanSchema');
const nuPagamentoSchema = require('./schemas/nuPagamentoSchema');
const bradescoSchema = require('./schemas/bradescoSchema');
const sicoobSchema = require('./schemas/sicoobSchema');
const c6BankSchema = require('./schemas/c6BankSchema');
const mostBanksDigitSchema = require('./schemas/mostBanksDigitSchema');
const SchemaErrorMessagesFactory = require('./SchemaErrorMessagesFactory');
const DefaultSchemaErrorMessagesFactory = require('./DefaultSchemaErrorMessagesFactory');
const merge = require('deepmerge');
const { regexes, banks } = require('@transfeeradev/api-enums');
const BankCodeService = require('./services/BankCodeService');
const ItauService = require('../lib/services/ItauService');

module.exports = class ValidationSchemaFactory {
  constructor(bankCode, bankAccount) {
    this._bankCode = bankCode;
    this._bankAccount = bankAccount;
  }

  build() {
    const bankInitialSchemaWithoutMessages = this.getBankInitialSchemaWithoutMessages();
    return this._getDefaultErrorMessagesBySchema(bankInitialSchemaWithoutMessages);
  }

  getBankInitialSchemaWithoutMessages() {
    const bankSchema = this._getBankSchemaByCode();
    return merge.all([defaultSchema, mostBanksDigitSchema, bankSchema], {
      arrayMerge: (target, source) => source
    });
  }

  _getBankSchemaByCode() {
    switch (BankCodeService.format(this._bankCode)) {
      case BankCodeService.format(banks.SANTANDER.code):
        return santanderSchema;

      case BankCodeService.format(banks.ITAU.code):
        return ItauService.isItiAccount(this._bankAccount && this._bankAccount.agency) ? itiSchema : itauSchema;

      case BankCodeService.format(banks.BANCO_DO_BRASIL.code):
        return bancoDoBrasilSchema;

      case BankCodeService.format(banks.CAIXA_ECONOMICA.code):
        return caixaSchema;

      case BankCodeService.format(banks.INTER.code):
        return interSchema;

      case BankCodeService.format(banks.AGIPLAN.code):
        return agiplanSchema;

      case BankCodeService.format(banks.NU_PAGAMENTO.code):
        return nuPagamentoSchema;

      case BankCodeService.format(banks.BRADESCO.code):
        return bradescoSchema;

      case BankCodeService.format(banks.SICOOB.code):
        return sicoobSchema;

      case BankCodeService.format(banks.C6_BANK.code):
        return c6BankSchema;

      case BankCodeService.format(banks.CELCOIN.code):
        return celcoinSchema;

      default:
        return {};
    }
  }

  _getDefaultErrorMessagesBySchema(schema) {
    const schemaMessages = new SchemaErrorMessagesFactory(schema).build();
    const defaultSchemaWithErrorMessages = new DefaultSchemaErrorMessagesFactory(schema, schemaMessages).build();
    const schemaWithMessages = merge.all([{}, defaultSchemaWithErrorMessages, schema]);

    if (schemaWithMessages.bankCode.pattern === regexes.bankAccount.BANK_CODE) {
      schemaWithMessages.bankCode.errorMessage = schemaMessages.BANK_CODE_FORMAT_ERROR.message;
      schemaWithMessages.bankCode.errorCode = schemaMessages.BANK_CODE_FORMAT_ERROR.code;
      schemaWithMessages.bankCode.errorData = schemaMessages.BANK_CODE_FORMAT_ERROR.data;
    }

    if (schemaWithMessages.bankISPB.pattern === regexes.bankAccount.BANK_ISPB) {
      schemaWithMessages.bankISPB.errorMessage = schemaMessages.BANK_ISPB_FORMAT_ERROR.message;
      schemaWithMessages.bankISPB.errorCode = schemaMessages.BANK_ISPB_FORMAT_ERROR.code;
      schemaWithMessages.bankISPB.errorData = schemaMessages.BANK_ISPB_FORMAT_ERROR.data;
    }

    if (schemaWithMessages.account.exactLength) {
      schemaWithMessages.account.errorMessage = schemaMessages.ACCOUNT_EXACT_LENGTH.message;
      schemaWithMessages.account.errorCode = schemaMessages.ACCOUNT_EXACT_LENGTH.code;
      schemaWithMessages.account.errorData = schemaMessages.ACCOUNT_EXACT_LENGTH.data;
    }

    if (schemaWithMessages.agency.pattern === regexes.bankAccount.AGENCY_ONE) {
      schemaWithMessages.agency.errorMessage = schemaMessages.AGENCY_ONE.message;
      schemaWithMessages.agency.errorCode = schemaMessages.AGENCY_ONE.code;
      schemaWithMessages.agency.suggestion = schemaMessages.AGENCY_ONE.suggestion;
    }

    if (schemaWithMessages.agency.digit.pattern === regexes.bankAccount.DIGIT) {
      schemaWithMessages.agency.digit.errorMessage = schemaMessages.AGENCY_DIGIT_NUMERIC_ALSO_WITH_X.message;
      schemaWithMessages.agency.digit.errorCode = schemaMessages.AGENCY_DIGIT_NUMERIC_ALSO_WITH_X.code;
      schemaWithMessages.agency.digit.errorData = schemaMessages.AGENCY_DIGIT_NUMERIC_ALSO_WITH_X.data;
    }

    if (schemaWithMessages.account.digit.pattern === regexes.bankAccount.DIGIT) {
      schemaWithMessages.account.digit.errorMessage = schemaMessages.ACCOUNT_DIGIT_NUMERIC_ALSO_WITH_X.message;
      schemaWithMessages.account.digit.errorCode = schemaMessages.ACCOUNT_DIGIT_NUMERIC_ALSO_WITH_X.code;
      schemaWithMessages.account.digit.errorData = schemaMessages.ACCOUNT_DIGIT_NUMERIC_ALSO_WITH_X.data;
    }

    if (schemaWithMessages.account.maxLength && schemaWithMessages.account.minLength) {
      schemaWithMessages.account.errorMessage = schemaMessages.ACCOUNT_MAX_MIN_LENGTH.message;
      schemaWithMessages.account.errorCode = schemaMessages.ACCOUNT_MAX_MIN_LENGTH.code;
      schemaWithMessages.account.errorData = schemaMessages.ACCOUNT_MAX_MIN_LENGTH.data;
    }

    return schemaWithMessages;
  }
};
